import React, { Component } from 'react';
import './Intro.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import arrowdown from "../../img/arrow-down.png";
import $ from "jquery"
class Intro extends Component {

  componentDidMount(){
    AOS.init({
      duration : 1200,
      disable: 'mobile'
    });

    $('.arrow-down').on('click', function(){
      const introheight = $('#intro').height() + 175;
      console.log(introheight);
      $(this).addClass('animate');
      $('html, body').stop().animate({
        scrollTop: introheight
      }, 1000);
      return false;
      $(this).removeClass('animate');
    });
  }

  render() {
    console.log(this.props);

    return (
      <div>
        <div data-aos='fade-up' className="d-flex align-items-center standard-padding" id="intro" style={{backgroundImage: "url(" + this.props.background + ")",backgroundPosition: 'center'}}>
          <div className="content-wrapper container-fluid d-none d-md-block">
            <div className="row">
              <div className="col-12 col-md-6 pr-md-5">
                <h1 data-aos='fade-up' data-aos-delay="500">{this.props.title}</h1>
                <h3 data-aos='fade-up' data-aos-delay="600">{this.props.subtitle}</h3>
                <hr data-aos='fade-up' data-aos-delay="700"/>
                <div data-aos='fade-up' data-aos-delay="900" dangerouslySetInnerHTML={{__html: this.props.content}}>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-block d-md-none intro-text">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 pr-md-5">
                <h1>{this.props.title}</h1>
                <h3>{this.props.subtitle}</h3>
                <hr className="black" />
                <div dangerouslySetInnerHTML={{__html: this.props.content}}>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`arrow-down show`} ><img src={arrowdown} alt="arrow down"/></div>
      </div>

    )
  }

}

export default Intro;
